import * as _ from 'lodash'
import * as React from 'react'
import { Alert, Badge, Col, Row } from 'reactstrap';
import { DataList, DataListRowLink } from '../../../../components/ui/DataList';
import { IHierarchyStudies, ISegmentReference, ISurveyReference } from '../../interfaces';

interface IPairSegmentsAndSurveysProps {
  project: string
  selectedSegments: ISegmentReference[]
  selectedSurveys: ISurveyReference[]
  onChange: (values: IHierarchyStudies[]) => void
  values: IHierarchyStudies[]
}

interface IPairSegmentsAndSurveysState {
  selectedSegmentAvid: string
}

export class PairSegmentsAndSurveys extends React.Component<IPairSegmentsAndSurveysProps, IPairSegmentsAndSurveysState> {
  state: IPairSegmentsAndSurveysState = {
    selectedSegmentAvid: ''
  }

  componentWillMount() {
    const { project, selectedSegments } = this.props
    if (selectedSegments.length > 0) {
      const selectedSegmentAvid = selectedSegments[0].avid

      this.setState({ selectedSegmentAvid })
      this.checkForDepreciatedValues()
    }
  }

  checkForDepreciatedValues() {
    let newValues = [...this.props.values]
    const { selectedSegments, selectedSurveys } = this.props
    const preFilterLength = newValues.length

    newValues = newValues.filter((value) => {
      const hasSegment = selectedSegments.some((s) => s.avid === value.avid)
      const hasSurvey = selectedSurveys.some((s) => s.surveyNewAbbreviation === value.surveyAbbr)

      return hasSegment && hasSurvey
    })

    const postFilterLength = newValues.length

    if (postFilterLength !== preFilterLength) {
      this.props.onChange(newValues)
    }
  }

  togglePair(survey: ISurveyReference) {
    const { selectedSegmentAvid } = this.state
    const values = [...this.props.values]
    const surveyIndex = values.findIndex((v) =>
      v.surveyAbbr === survey.surveyNewAbbreviation && v.avid === selectedSegmentAvid
    )

    if (surveyIndex >= 0) {
      values.splice(surveyIndex, 1)
    } else {
      values.push({
        avid: selectedSegmentAvid,
        surveyAbbr: survey.surveyNewAbbreviation
      })
    }

    this.props.onChange(values)
  }

  getAvidLength(avid: string) {
    const { values } = this.props

    const studies = values.filter((value) => value.avid === avid)

    return studies.length
  }

  isChecked(survey: ISurveyReference) {
    const { selectedSegmentAvid } = this.state
    const { values } = this.props
    const studies = values.filter((value) => value.avid === selectedSegmentAvid)

    return studies.findIndex((s) => s.surveyAbbr === survey.surveyNewAbbreviation) >= 0
  }

  render() {
    const { selectedSurveys, selectedSegments } = this.props

    if (selectedSegments.length === 0) {
      return (
        <Alert color="warning">
          <h3>
            <i className="fas fa-fw fa-exclamation-triangle" />&nbsp;
            <span>No segments selected to pair. Click Finish below to complete project creation or go back to add segments to be paired for surveys.</span>
          </h3>
        </Alert>
      )
    }
    return (
      <Row>
        <Col xs={5}>
          <DataList>
            {selectedSegments.map((hierarchy, index) =>
              <DataListRowLink key={hierarchy.avid}
                onClick={() => this.setState({ selectedSegmentAvid: hierarchy.avid })}
                active={this.state.selectedSegmentAvid === hierarchy.avid}>
                <Badge color="light">{this.getAvidLength(hierarchy.avid)}</Badge>
                <span>{hierarchy.avidLabel}</span>
              </DataListRowLink>
            )}
          </DataList>
        </Col>
        <Col className="pt-3">
          <Row>
            {selectedSurveys.map((survey, index) =>
              <>
                {index % 2 === 0 &&
                  <div className="w-100" key={survey.surveyNewAbbreviation + 0}></div>
                }
                <Col key={survey.surveyNewAbbreviation + 1}>
                  <p>
                    <input type="checkbox"
                      id={survey.surveyNewAbbreviation}
                      onClick={() => this.togglePair(survey)}
                      checked={this.isChecked(survey)} />
                    <label htmlFor={survey.surveyNewAbbreviation}>
                      <span>{survey.surveyLabel}&nbsp;</span>
                      <span className="text-muted">({survey.surveyNewAbbreviation})</span>
                    </label>
                  </p>
                </Col>
              </>
            )}
          </Row>
        </Col>
      </Row>
    )
  }
}
